document.addEventListener('DOMContentLoaded', () => {
  const headerGroup = document.querySelector('.header-group');
  let lastScrollY = window.scrollY;
  let isHeaderVisible = true;
  let placeholder = null;

  if (headerGroup) {
    headerGroup.style.transition = 'transform 0.3s ease-in-out';

    function handleScroll() {
      const currentScrollY = window.scrollY;
      const scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';

      if (currentScrollY > 100) {
        if (!headerGroup.classList.contains('fixed')) {
          placeholder = document.createElement('div');
          placeholder.id = 'header-placeholder';
          placeholder.style.height = headerGroup.offsetHeight + 'px';
          placeholder.style.transition = 'height 0.3s ease-in-out';
          headerGroup.parentNode.insertBefore(placeholder, headerGroup);
        }

        headerGroup.classList.remove('relative');
        headerGroup.classList.add('fixed', 'top-0', 'left-0', 'right-0', 'shadow-lg', 'bg-white');

        if (scrollDirection === 'down' && currentScrollY > 200 && isHeaderVisible) {
          headerGroup.style.transform = 'translateY(-100%)';
          isHeaderVisible = false;
        } else if (scrollDirection === 'up' && !isHeaderVisible) {
          headerGroup.style.transform = 'translateY(0)';
          isHeaderVisible = true;
        }
      } else {
        headerGroup.classList.remove('fixed', 'top-0', 'left-0', 'right-0', 'shadow-lg', 'bg-white');
        headerGroup.classList.add('relative');
        headerGroup.style.transform = 'translateY(0)';
        isHeaderVisible = true;

        if (placeholder) {
          placeholder.remove();
          placeholder = null;
        }
      }

      lastScrollY = currentScrollY;
    }

    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    window.addEventListener('resize', () => {
      if (placeholder) {
        placeholder.style.height = headerGroup.offsetHeight + 'px';
      }
    });
  }

  const mobileNav = document.getElementById('mobile-nav');
  const mobileNavToggle = document.getElementById('mobile-nav-toggle');
  const mobileNavClose = document.getElementById('mobile-nav-close-header');

  function toggleMobileNav(isOpen) {
    mobileNav.classList.toggle('translate-x-full', !isOpen);
    mobileNav.setAttribute('aria-hidden', !isOpen);
    document.body.style.overflow = isOpen ? 'hidden' : '';
    if (isOpen && mobileNavClose) mobileNavClose.focus();
    if (!isOpen && mobileNavToggle) mobileNavToggle.focus();
  }

  function toggleSubmenu(button, level = 'first') {
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    const dataAttr = level === 'first' ? 'data-open' : 'data-open-second';
    const panelAttr = level === 'first' ? 'data-panel' : 'data-panel-second';
    const panelIndex = button.getAttribute(dataAttr);
    const submenu = document.querySelector(`[${panelAttr}="${panelIndex}"]`);

    if (submenu) {
      submenu.classList.toggle('translate-x-full', isOpen);
      submenu.classList.toggle('translate-x-0', !isOpen);
      submenu.classList.toggle('pointer-events-none', isOpen);
      submenu.classList.toggle('pointer-events-auto', !isOpen);
      submenu.setAttribute('aria-hidden', isOpen);
      button.setAttribute('aria-expanded', !isOpen);
    }
  }

  if (mobileNavToggle) mobileNavToggle.addEventListener('click', () => toggleMobileNav(true));
  if (mobileNavClose) mobileNavClose.addEventListener('click', () => toggleMobileNav(false));

  document.querySelectorAll('[data-open]').forEach((button) => {
    button.addEventListener('click', () => toggleSubmenu(button, 'first'));
  });

  document.querySelectorAll('[data-open-second]').forEach((button) => {
    button.addEventListener('click', () => toggleSubmenu(button, 'second'));
  });

  document.querySelectorAll('[data-back]').forEach((button) => {
    button.addEventListener('click', () => {
      const submenu = button.closest('[data-panel]');
      if (submenu) {
        const panelIndex = submenu.getAttribute('data-panel');
        const trigger = document.querySelector(`[data-open="${panelIndex}"]`);
        if (trigger) toggleSubmenu(trigger, 'first');
      }
    });
  });

  document.querySelectorAll('[data-back-second]').forEach((button) => {
    button.addEventListener('click', () => {
      const panelIndex = button.getAttribute('data-back-second');
      const trigger = document.querySelector(`[data-open-second="${panelIndex}"]`);
      if (trigger) toggleSubmenu(trigger, 'second');
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !mobileNav.classList.contains('translate-x-full')) {
      toggleMobileNav(false);
    }
  });

  mobileNav.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') {
      const focusableElements = mobileNav.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (e.shiftKey && document.activeElement === firstElement) {
        e.preventDefault();
        lastElement.focus();
      } else if (!e.shiftKey && document.activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  });

  function setupHoverMenu(triggerSelector, menuSelector, delay = 300) {
    const triggers = document.querySelectorAll(triggerSelector);
    const menus = document.querySelectorAll(menuSelector);
    let hideTimer = null;
    let currentMenu = null;

    triggers.forEach((trigger) => {
      const triggerId = trigger.getAttribute(triggerSelector.match(/\[(.*?)\]/)[1]);
      const menu = document.querySelector(`${menuSelector}="${triggerId}"]`);

      if (menu) {
        trigger.addEventListener('mouseenter', () => {
          if (hideTimer) clearTimeout(hideTimer);
          menus.forEach((m) => m.classList.add('hidden'));
          menu.classList.remove('hidden');
          currentMenu = menu;
        });

        trigger.addEventListener('mouseleave', () => {
          hideTimer = setTimeout(() => {
            if (currentMenu && !currentMenu.matches(':hover')) {
              currentMenu.classList.add('hidden');
              currentMenu = null;
            }
          }, delay);
        });

        menu.addEventListener('mouseenter', () => {
          if (hideTimer) clearTimeout(hideTimer);
        });

        menu.addEventListener('mouseleave', () => {
          menu.classList.add('hidden');
          currentMenu = null;
        });
      }
    });
  }

  setupHoverMenu('[data-main-submenu-trigger]', '[data-main-submenu');
  setupHoverMenu('[data-submenu-trigger]', '[data-submenu');
});
